var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 148,
    viewBox: "0 0 181 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29963_370703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6996 143.182C46.242 146.206 53.4263 147.857 60.6329 147.985C79.8363 148.325 88.5987 142.705 117.017 144.619C121.871 144.946 126.66 146.075 131.517 146.35C160.789 148.009 184.833 114.551 180.491 75.392C178.293 55.5687 166.552 38.0028 151.37 25.0682C51.0222 -60.4261 -61.4941 96.399 39.6996 143.182Z",
    fill: "#F0F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0353 55.6684C30.4635 53.5345 31.7298 51.3412 33.8637 50.7694L111.138 30.0639C113.272 29.4921 115.465 30.7585 116.037 32.8923L127.425 75.3931C127.997 77.5269 126.73 79.7203 124.596 80.292L47.3223 100.998C45.1884 101.569 42.9951 100.303 42.4233 98.1691L31.0353 55.6684Z",
    fill: "url(#paint0_linear_29963_370703)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.0703,
    y: 59.5312,
    width: 88,
    height: 11,
    transform: "rotate(-15 32.0703 59.5312)",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.23 64.5312H60.2305C57.469 64.5312 55.2305 66.7698 55.2305 69.5312V113.531C55.2305 116.293 57.469 118.531 60.2305 118.531H140.23C142.992 118.531 145.23 116.293 145.23 113.531V69.5312C145.23 66.7698 142.992 64.5312 140.23 64.5312Z",
    fill: "url(#paint1_linear_29963_370703)",
    stroke: "#F0F6FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_29963_370703)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.2305,
    y: 83.5312,
    width: 12,
    height: 10,
    rx: 1.17253,
    fill: "url(#paint2_linear_29963_370703)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.2305,
    y: 83.5312,
    width: 12,
    height: 10,
    rx: 1.17253,
    fill: "url(#paint3_linear_29963_370703)",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62.2305,
    y: 97.5312,
    width: 32,
    height: 4,
    rx: 1,
    fill: "#CEE6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.2305,
    y: 103.531,
    width: 43,
    height: 4,
    rx: 1,
    fill: "#CEE6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_29963_370703",
    x: 62.035,
    y: 83.3358,
    width: 12.3908,
    height: 10.3908,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.195422,
    dy: 0.195422
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0977109
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.156863 0 0 0 0 0.243137 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_29963_370703"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.195422,
    dy: -0.195422
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0977109
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.979167 0 0 0 0 0.979167 0 0 0 0 0.979167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_29963_370703",
    result: "effect2_innerShadow_29963_370703"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29963_370703",
    x1: 60.6281,
    y1: 43.5979,
    x2: 64.4036,
    y2: 107.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A75D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819557,
    stopColor: "#003DB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29963_370703",
    x1: 87.939,
    y1: 65.5312,
    x2: 75.072,
    y2: 128.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A75D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819557,
    stopColor: "#003DB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29963_370703",
    x1: 73.8305,
    y1: 83.0767,
    x2: 63.2238,
    y2: 93.3138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503416,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29963_370703",
    x1: 63.3305,
    y1: 84.0994,
    x2: 73.6185,
    y2: 91.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939616,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29963_370703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 148,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardAppIcon);
export default __webpack_public_path__ + "static/media/CreditCardAppIcon.d22cab2fa67efcee2defd1fefdda3647.svg";
export { ForwardRef as ReactComponent };